import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';

const FloatingQuiz = () => {
  const [hidden, setHidden] = useState(() =>
    localStorage.getItem('quiz_hidden') === '1' || localStorage.getItem('quiz_completed') === '1'
  );
  const [caught, setCaught] = useState(false);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isInstitutional } = useTheme();

  const onFormazione = location.pathname === '/formazione';

  useEffect(() => {
    const check = () => {
      if (localStorage.getItem('quiz_completed') === '1') setHidden(true);
    };
    window.addEventListener('storage', check);
    const interval = setInterval(check, 2000);
    return () => { window.removeEventListener('storage', check); clearInterval(interval); };
  }, []);

  const handleCatch = () => {
    setCaught(true);
    setTimeout(() => {
      navigate('/formazione');
      setTimeout(() => {
        const el = document.querySelector('[data-testid="placement-test"]');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 500);
    }, 400);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setHidden(true);
    localStorage.setItem('quiz_hidden', '1');
  };

  if (hidden || onFormazione) return null;

  const accent = isInstitutional ? '#C4532D' : '#00FF41';

  return (
    <>
      <style>{`
        @keyframes quizPulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 ${accent}40; }
          50% { transform: scale(1.1); box-shadow: 0 0 16px 4px ${accent}30; }
        }
        @keyframes quizWiggle {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-8deg); }
          75% { transform: rotate(8deg); }
        }
        .quiz-idle {
          animation: quizPulse 2.5s ease-in-out infinite;
        }
        .quiz-hover {
          animation: quizWiggle 0.4s ease-in-out infinite;
          transform: scale(1.15) !important;
        }
      `}</style>
      <div
        data-testid="floating-quiz"
        className="fixed z-[9998]"
        style={{ right: '16px', bottom: '58px' }}
      >
        <div className="relative">
          <button
            onClick={handleClose}
            data-testid="quiz-close-btn"
            className="absolute -top-1 -right-1 z-10 w-4 h-4 flex items-center justify-center rounded-full text-[7px] font-bold"
            style={{ background: '#FF2D2D', color: '#fff', border: '1.5px solid #fff' }}
          >X</button>

          <button
            data-testid="quiz-catch-btn"
            onClick={handleCatch}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`block transition-all duration-300 ${caught ? '' : hovered ? 'quiz-hover' : 'quiz-idle'}`}
            style={{
              opacity: caught ? 0 : 1,
              borderRadius: '50%',
            }}
          >
            <div
              style={{
                width: '36px',
                height: '36px',
                background: isInstitutional ? '#FAF9F6' : '#0A0A0A',
                border: `2px solid ${accent}`,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <span style={{
                fontSize: '11px',
                fontWeight: 900,
                color: accent,
                fontFamily: "'Source Serif 4', serif",
                lineHeight: 1,
              }}>&lt;/?&gt;</span>
            </div>
          </button>

          {hovered && !caught && (
            <div className="absolute right-full mr-2 top-1/2 -translate-y-1/2 whitespace-nowrap px-2.5 py-1 rounded"
              style={{ background: '#FFD700', border: '1.5px solid #000', boxShadow: '0 2px 0 #000' }}>
              <p className="text-black font-black text-[8px] tracking-wider" style={{ fontFamily: "'JetBrains Mono', monospace" }}>QUIZ</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FloatingQuiz;
